import {Box, Container, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useAuth} from "../context/AuthContext";
import {api} from "../services/apiService";
import {formatDateISO} from "../utils/helpers";
import {useNavigate} from "react-router-dom";
import Card from "@mui/material/Card";


export default function Dashboard() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()
    const {user} = useAuth();

    const [nextBooking, setNextBooking] = useState(null);

    useEffect(() => {
        const promises = [];

        promises.push(api.get('bookings/get_next_booking')
            .then(res => {
                setNextBooking(res.data);
            })
            .catch(err => {

            }))

        Promise.all(promises).then(() => setLoading(false));
    }, []);


    return (
        <Container maxWidth={"lg"}>
            <Box>
                <Typography variant="h1" gutterBottom>
                    Dashboard
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Bienvenue {user && `${user.firstName} ${user.lastName}`} sur votre tableau de bord.
                </Typography>
            </Box>

            {!loading && (
                <React.Fragment>
                    {nextBooking !== null ? (
                            <Card sx={{p: 2, mt: 4, cursor: "pointer"}}
                                  onClick={() => navigate(`/bookings/details/${nextBooking.id}`)}>
                                <Typography variant="h5" gutterBottom>
                                    Votre prochaine réservation
                                </Typography>
                                <Typography variant="body1">
                                    <b>Réservation n° :</b> {nextBooking.bookingRef}<br/>
                                    <b>Client :</b> {nextBooking.client.name}<br/>
                                    <b>Date :</b> {formatDateISO(nextBooking.startTime)}<br/>
                                    <b>Statut :</b> {nextBooking.status.label}
                                </Typography>
                            </Card>
                        )
                        :
                        (
                            <Card sx={{p: 2, mt: 4}}>
                                <Typography variant="h5" gutterBottom>
                                    Votre prochaine réservation
                                </Typography>
                                <Typography variant="body1">
                                    Aucune réservation à venir.
                                </Typography>
                            </Card>
                        )
                    }
                </React.Fragment>
            )
            }
        </Container>
    )
        ;
}